<template>
    <MyAdmin></MyAdmin>
</template>

<script>
    import MyAdmin from "../components/MyAdmin";

    export default {
        name: "my-admin",
        components: {
            MyAdmin,
        }
    };
</script>